import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, Event } from '@angular/router';

@Component({
  selector: 'stars-elements-character-modal',
  templateUrl: './elements-character-modal.component.html',
  styleUrls: ['./elements-character-modal.component.scss']
})
export class ElementsCharacterModalComponent implements OnInit, OnDestroy {
  elementsCharacterDialogRef =
    inject<MatDialogRef<ElementsCharacterModalComponent>>(MatDialogRef);
  private router = inject(Router);

  name: string;
  image: string;

  constructor() {
    const data = inject(MAT_DIALOG_DATA);

    this.name = data.name;
    this.image = data.image;
  }

  ngOnInit() {
    this.router.events.subscribe((event: Event) => {
      this.elementsCharacterDialogRef.close();
    });
  }

  ngOnDestroy(): void {
    this.elementsCharacterDialogRef.close();
  }
}
